import { FC } from "react";
import Layout from "components/Layout";
import { useAuthContext } from "components/AuthProvider";

const Dashboard: FC = () => {
  const { user } = useAuthContext();
  return (
    <Layout isPrivate>
      <p>Welcome! {user?.name}</p>
    </Layout>
  );
};

export default Dashboard;
